module.exports = __webpack_public_path__ + "static/media/banner1.9206e6cf.png";